import React from "react";
import { motion } from "framer-motion";
import { FlameIcon } from "lucide-react";
const TOTAL = 100;
const LEFT = 7;
export function ScarcityBar() {
  const pct = (TOTAL - LEFT) / TOTAL * 100;
  return <div className="w-full" data-id="element-264" data-mp="2l5plpx8ens8c">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-265" data-mp="2l4o0x11l7rdf">
        <span className="flex items-center gap-1.5 text-gold" data-id="element-266" data-mp="2q2pu4esq972m">
          <FlameIcon className="h-4 w-4" aria-hidden data-id="element-267" data-mp="2b7084gnjktxw" /> Only {LEFT} spots left at the promotional price
        </span>
        <span className="text-white" data-id="element-268" data-mp="2g63a1s886k1n">{Math.round(pct)}%</span>
      </div>
      <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-white/15" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-269" data-mp="226bq7av129fq">
        <motion.div className="h-full rounded-full bg-red-500" initial={{
        width: "60%"
      }} whileInView={{
        width: `${pct}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-270" data-mp="fgpq5pvlm2o" />
      </div>
    </div>;
}